import rest from "@/rest-client";

export const managementInventoryImport = {
  moduleName: "managementInventoryImport",
  persistent: ["selectedJob"],
  namespaced: true,
  state: {
    selectedOrganization: false,
    selectedJob: undefined,
    jobs: undefined,
    jobItems: [],
    jobItemsIndex: {},
    cancellingJobIds: [],
  },
  getters: {
    selectedOrganization: (state) => state.selectedOrganization,
    selectedJob: (state) => state.selectedJob,
    jobItems: (state) => state.jobItems,
    isCancelling: (state) => (jobId) => state.cancellingJobIds.includes(jobId),
  },
  mutations: {
    selectedOrganization: (state, value) => (state.selectedOrganization = value),
    selectedJob: (state, value) => (state.selectedJob = value),
    jobItems: (state, value) => {
      const items = value || [];
      const index = {};
      items.forEach((item, i) => { if (item._id) index[item._id] = i; });
      state.jobItems = items.map(Object.freeze);
      state.jobItemsIndex = index;
    },
    // Tek seferlik commit yerine batch: birden fazla event tek commit'te işlenir
    addJobItemBatch: (state, payloads) => {
      const selectedJobId = state.selectedJob?._id;

      for (const value of payloads) {
        const payload = value?.jobItem || value;
        const jobItemId = payload?._id;
        if (!jobItemId) continue;

        const payloadJobId = payload?.job?._id || payload?.job;
        if (selectedJobId && payloadJobId && payloadJobId !== selectedJobId) continue;

        const existingIndex = state.jobItemsIndex[jobItemId];
        if (existingIndex !== undefined) {
          state.jobItems.splice(existingIndex, 1, Object.freeze({ ...state.jobItems[existingIndex], ...payload }));
        } else {
          state.jobItemsIndex[jobItemId] = state.jobItems.length;
          state.jobItems.push(Object.freeze(payload));
        }
      }
    },
    startCancelling(state, jobId) {
      if (!jobId) return;
      if (!state.cancellingJobIds.includes(jobId)) {
        state.cancellingJobIds.push(jobId);
      }
    },
    stopCancelling(state, jobId) {
      state.cancellingJobIds = state.cancellingJobIds.filter((id) => id !== jobId);
    },
  },
  actions: {
    async fetchJobItems({ commit }, payload) {
      try {
        const response = await rest.post(`/management/inventory/import/job-item`, { organizationId: payload.organizationId, jobId: payload.jobId });
        commit("jobItems", response.data);
        return response;
      } finally {
      }
    },
    async paginateJobs({ commit }, payload) {
      try {
        const response = await rest.post(`/management/inventory/import/job/paginate`, { organizationId: payload.organizationId });
        return response;
      } finally {
      }
    },
    async fetchOrganizationDetail({ commit }, id) {
      try {
        const response = await rest.get(`/management/organization/${id}`);
        commit("selectedOrganization", response.data);
        return response;
      } finally {
      }
    },
    async cancelJob({ commit, getters }, payload) {
      const jobId = payload?.jobId;
      if (!jobId) {
        return;
      }

      commit("startCancelling", jobId);
      try {
        await rest.post(`/management/inventory/import/job/cancel`, { jobId });

        const currentJob = getters.selectedJob;
        if (currentJob && currentJob._id === jobId) {
          commit("selectedJob", {
            ...currentJob,
            status: currentJob.status === "CANCELLED" ? currentJob.status : "CANCEL_REQUESTED",
          });
        }
      } finally {
        commit("stopCancelling", jobId);
      }
    },
  },
};
